<template>
  <Header/>

  <div class="border-b-[2px] border-postRed py-1">
    <LocationChooser/>
  </div>

  <div class="w-content-standard mx-auto mb-8 pt-10">
    <div v-if="message" class="font-semibold text-xl text-postRed mb-4">{{ message }}</div>

    <router-link to="/ConfigurableForm/admin_mail" class="form-link-button">Admin Mail</router-link>
    
    <router-link to="/ConfigurableForm/deposits" class="form-link-button">Deposits</router-link>

    <router-link to="/ChooseUserConfigurableForm/employee_onboard" class="form-link-button">Employee Onboard</router-link>

    <router-link to="/ChooseUserConfigurableForm/employee_payment" class="form-link-button">Employee Payments</router-link>

    <router-link to="/ChooseUserConfigurableForm/employee_records" class="form-link-button">Employee Records</router-link>

    <router-link to="/ConfigurableForm/" class="form-link-button">Fantasy League Photo (pending)</router-link>
  
    <router-link to="/ConfigurableForm/invoices" class="form-link-button">Invoices</router-link>

    <router-link to="/ConfigurableForm/repair_request" class="form-link-button">Repair Request</router-link>
        
  </div>

</template>

<script>
import { ref, onMounted } from 'vue';
import axios from 'axios';
import { useRoute } from "vue-router";
import { FormKitSchema } from '@formkit/vue';
import Datepicker from 'vue3-datepicker';
import Header from "./Header.vue";
import LocationChooser from '@/components/LocationChooser.vue'
import { useAuthStore } from '../store/auth';

export default {
  name: 'Home',
  components: {
    LocationChooser,
    Header,
    Datepicker, // Register the Datepicker component
  },
  setup() {
    const authStore = useAuthStore()
    const route = useRoute()
    // Previous submit message
    const message = route.query.message

    const schema = ref([
      {
        $el: 'h1',
        children: 'Register',
        attrs: {
          class: 'text-2xl font-bold mb-4',
        },
      },
      {
        $formkit: 'select', // Vendor dropdown
        name: 'vendor',
        label: 'Vendor',
        options: {
          'Vendor A': 'Vendor A',
          'Vendor B': 'Vendor B',
        },
        validation: 'required',
        help: 'Please select your vendor.',
      },
      {
        $formkit: 'text',
        name: 'amount',
        label: 'Amount',
        validation: 'required',
      },
      {
        $formkit: 'file',
        name: 'upload',
        label: 'Upload file',
        help: 'Upload a file',
        validation: 'required',
      },
    ]);

    // Fetch the user data when the component is mounted
    onMounted(() => {
      //getUser();
      authStore.validate_session()

      // seed cache of staff list
      const response = axios.get(`/api/staff`);
    });

    const formData = ref({
      invoice_date: null, // Add this field for the date picker
    });

    const submit_document_generation = (formData) => {
      const data = new FormData();
      data.append('vendor', formData.vendor);
      data.append('invoice_date', formData.invoice_date);
      data.append('amount', formData.amount);
      data.append('upload', formData.upload); // Append the file

      axios.post('/api/submit', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
          .then(response => {
            console.log('Form submitted successfully:', response.data);
          })
          .catch(error => {
            console.error('Error submitting form:', error);
          });
    };

    const user = ref(null); // Declare a reactive user variable

    // const getUser = async () => {
    //   try {
    //     const response = await axios.get('/api/user'); // Fetch user data from API
    //     user.value = response.data; // Assign the API response to the user ref
    //   } catch (error) {
    //     console.error('Error fetching user data:', error); // Handle any errors
    //   }
    // };

    const logout = async () => {
      try {
        await axios.post('/api/logout'); // Adjust this route to match your Laravel backend
        window.location.href = '/#/login'; // Redirect to login page after logout
      } catch (error) {
        console.error('Error logging out:', error);
      }
    };

    // Return the user ref so it can be used in the template
    return {
      user,
      schema,
      formData,
      logout,
      submit_document_generation,
      message
    };
  },
};
</script>

<style>

</style>